import { ElementState, Preview } from "@creatomate/preview";

import { Organization, Story, Template } from "chq";

import getDefaultSource from "./getDefaultSource";
import { abkAllyTemplate, abkPrideTemplate, activisionAllyTemplate,
  activisionPrideTemplate, assurantBlackLogo, assurantColorLogo, assurantVideoTemplateBlue, assurantVideoTemplateGreen, assurantVideoTemplateOrange, assurantWhiteLogo, blizzardAllyTemplate, blizzardPrideTemplate, brandedTemplateForEmployeeTalkingVideoIRCTemplate, brandedTemplateForEmployeeTalkingVideoTemplate, comcastVideoTemplate_16_9, comcastVideoTemplate_1_1, comcastVideoTemplate_9_16, ilegWeek, ilegWeekImage, intuitiveIntroOutroTemplate, intuitiveIntroTemplate, intuitiveNameAndTitleOverlay, intuitiveOutroTemplate, intuitiveTestimonialTemplate, intuitiveVideoTemplateNew, ircDefaultVideoTemplates, IrcDefaultVideoTemplateWithOutro, ircHumanitarianTemplate, IrcPortraitDefaultVideoTemplateWithOutro, merckHorizontal, merckHorizontalWithNameTitleAndLogo, merckHorizontalWithPrompt, merckHorizontalWithPromptAndLogo, merckVertical, merckVerticalWithLogo, merckVerticalWithNameTitleAndLogo, merckVerticalWithPrompt, microsoftAmplifyTemplateBlackOutro, microsoftAmplifyTemplateWhiteOutro, microsoftFlourishTemplateBlackOutro, microsoftFlourishTemplateWhiteOutro, microsoftMultiplyTemplateBlackOutro, microsoftMultiplyTemplateWhiteOutro, microsoftPrismTemplateBlackOutro, microsoftPrismTemplateWhiteOutro, movingCirclesInBackgroundWithNameAndTitleIRCTemplate, movingCirclesInBackgroundWithNameAndTitleTemplate, newHireWelcomeTemplate, premiseHealthLandscapeBlueVideoTemplate, premiseHealthLandscapeOrangeVideoTemplate, recognitionWeekImageOverlayBlue, recognitionWeekImageOverlayGreen, recognitionWeekImageOverlayOrange, recognitionWeekImageOverlayPink, recognitionWeekImageOverlayPurple, recognitionWeekImageOverlayRed, recognitionWeekOverlayBlue, recognitionWeekOverlayGreen, recognitionWeekOverlayOrange, recognitionWeekOverlayPink, recognitionWeekOverlayPurple, recognitionWeekOverlayRed, recognitionWeekTemplateIntellia, recognitionWeekTemplateIntelliaImage, recognitionWeekTemplateIntelliaImageLandscape, recognitionWeekTemplateIntelliaLandscape, rtxCollinsAerospacePortraitVideoTemplate, rtxCollinsAerospaceVideoTemplate, rtxDefaultVideoTemplate, rtxPrattWhitneyPortraitVideoTemplate, rtxPrattWhitneyVideoTemplate, rtxRaytheonPortraitVideoTemplate, rtxRaytheonVideoTemplate, santanderLandscapeRedLogoOutro, santanderLandscapeRedWordmarkLogoOutro, santanderLandscapeWhiteWordmarkLogoOutro, santanderLandscapeWhiteWordmarkLogoOutroAnimation, santanderRed_4_5_LogoOutro, santanderWhite_4_5_LogoOutro, standardIRCTemplate, standardTemplate, storyPromptOverlayIRCTemplate, storyPromptOverlayTemplate, storyWithCaptionAndUserOverlayTemplate, synopsysDefaultPortraitVideoTemplate, synopsysDefaultVideoTemplate, trendOverlayTemplate, verizonTemplateBlackLandscape, verizonTemplateBlackPortrait, verizonTemplateWhiteLandscape, verizonTemplateWhitePortrait, zendeskStoryCaptionUserOverlay, zendeskTemplatewithCreamBackground, zendeskTemplatewithCreamBackgroundPortrait, zendeskTemplatewithEspressoBackground, zendeskTemplatewithEspressoBackgroundPortrait, zendeskTrendOverlay } from "../../sidebar/tabs/template/implementors/implementors";
import rtxCorpsPortraitVideoTemplate from "../../sidebar/tabs/template/implementors/rtx/videos/rtxCorpsPortraitVideoTemplate";
import newHireWelcomeIrcTemplate from "../../sidebar/tabs/template/implementors/irc/default-images/newHireWelcomeIrcTemplate";
import storyWithCaptionAndUserOverlayIrcTemplate from "../../sidebar/tabs/template/implementors/irc/default-images/storyWithCaptionAndUserOverlayIrcTemplate";
import trendOverlayIrcTemplate from "../../sidebar/tabs/template/implementors/irc/default-images/trendOverlayIrcTemplate";
import storyPromptOverlayPremiseTemplate from "../../sidebar/tabs/template/implementors/premisehealth/videos/storyPromptOverlayPremiseTemplate";
import movingCirclesInBackgroundWithNameAndTitlePremiseTemplate from "../../sidebar/tabs/template/implementors/premisehealth/videos/movingCirclesInBackgroundWithNameAndTitlePremiseTemplate";
import brandedTemplateForEmployeeTalkingVideoPremiseTemplate from "../../sidebar/tabs/template/implementors/premisehealth/videos/brandedTemplateForEmployeeTalkingVideoPremiseTemplate";

export interface ImplementorTemplateParams {
  template: Template;
  preview: Preview;
  mediaElements: ElementState[];
  defaultVideoProperties: Record<string, any>;
  organization: Organization;
  story?: Story;
  localfile?: File | { urls: any; alt_description: string };
}

const defaultVideoProperties = {
  x: "50%",
  y: "50%",
  height: "100%",
  border_radius: 0,
  clip: false
};

const templateFunctions: { [key: string]: (params: ImplementorTemplateParams) => Promise<void> } = {
  // default video templates
  "Standard template": standardTemplate,
  "Story Prompt Overlay": storyPromptOverlayTemplate,
  "Moving circles in background with name and title": movingCirclesInBackgroundWithNameAndTitleTemplate,
  "Branded template for Employee Talking Video": brandedTemplateForEmployeeTalkingVideoTemplate,

  // video templates
  "Assurant video template green": assurantVideoTemplateGreen,
  "Assurant video template blue": assurantVideoTemplateBlue,
  "Assurant video template orange": assurantVideoTemplateOrange,
  "Assurant Black Logo": assurantBlackLogo,
  "Assurant Color Logo": assurantColorLogo,
  "Assurant White Logo": assurantWhiteLogo,
  "Comcast Video Template_1x1": comcastVideoTemplate_1_1,
  "Comcast Video Template_9x16": comcastVideoTemplate_9_16,
  "Comcast Video Template_16x9": comcastVideoTemplate_16_9,
  "ILEG Week Learn, Grow, Perform (Video)": ilegWeek,
  "ILEG Week Empowered to Explore (Video)": ilegWeek,
  "ILEG Week Take the next step (Video)": ilegWeek,
  "ILEG Week Thinking & Talking Development (Video)": ilegWeek,
  "ILEG Week Winning Together (Video)": ilegWeek,
  "ILEG Week Dates (Video)": ilegWeek,
  "Recognition Week Overlay Blue Video": recognitionWeekOverlayBlue,
  "Recognition Week Overlay Green Video": recognitionWeekOverlayGreen,
  "Recognition Week Overlay Orange Video": recognitionWeekOverlayOrange,
  "Recognition Week Overlay Pink Video": recognitionWeekOverlayPink,
  "Recognition Week Overlay Purple Video": recognitionWeekOverlayPurple,
  "Recognition Week Overlay Red Video": recognitionWeekOverlayRed,
  "Recognition Week Template Intellia (Portrait)": recognitionWeekTemplateIntellia,
  "Recognition Week Template Intellia (Landscape)": recognitionWeekTemplateIntelliaLandscape,
  "RTX Template": rtxDefaultVideoTemplate,
  "RTX Template (Collins Aerospace)": rtxCollinsAerospaceVideoTemplate,
  "RTX Template (Pratt & Whitney)": rtxPrattWhitneyVideoTemplate,
  "RTX Template (Raytheon)": rtxRaytheonVideoTemplate,
  "RTX Portrait Template (Raytheon)": rtxRaytheonPortraitVideoTemplate,
  "RTX Portrait Template (Pratt & Whitney)": rtxPrattWhitneyPortraitVideoTemplate,
  "RTX Portrait Template (Collins Aerospace)": rtxCollinsAerospacePortraitVideoTemplate,
  "RTX Portrait Template (RTX Corp)": rtxCorpsPortraitVideoTemplate,
  "Intuitive Outro": intuitiveOutroTemplate,
  "Intuitive Intro": intuitiveIntroTemplate,
  "Intuitive Intro and Outro": intuitiveIntroOutroTemplate,
  "Intuitive video template": intuitiveVideoTemplateNew,
  "Intuitive name and title overlay": intuitiveNameAndTitleOverlay,
  "IRC Default Video Template": ircDefaultVideoTemplates,
  "IRC Landscape Video Template (with outro)": IrcDefaultVideoTemplateWithOutro,
  "IRC Portrait Video Template (with outro)": IrcPortraitDefaultVideoTemplateWithOutro,
  "Standard Template (IRC)": standardIRCTemplate,
  "Story Prompt Overlay (IRC)": storyPromptOverlayIRCTemplate,
  "Moving circles in background with name and title (IRC)": movingCirclesInBackgroundWithNameAndTitleIRCTemplate,
  "Branded template for Employee Talking Video (IRC)": brandedTemplateForEmployeeTalkingVideoIRCTemplate,
  "Merck Vertical Template": merckVertical,
  "Merck Vertical Template with Prompt": merckVerticalWithPrompt,
  "Merck Horizontal Template with Prompt and Logo": merckHorizontalWithPromptAndLogo,
  "Merck Horizontal Template with Prompt": merckHorizontalWithPrompt,
  "Merck Horizontal Template": merckHorizontal,
  "Merck Vertical Template with Logo": merckVerticalWithLogo,
  "Merck Horizontal Template with Name, Title and Logo": merckHorizontalWithNameTitleAndLogo,
  "Merck Vertical Template with Name, Title and Logo": merckVerticalWithNameTitleAndLogo,
  "Microsoft Amplify Template w/ Black Outro": microsoftAmplifyTemplateBlackOutro,
  "Microsoft Amplify Template (Portrait)": microsoftAmplifyTemplateWhiteOutro,
  "Microsoft Flourish Template w/ Black Outro": microsoftFlourishTemplateBlackOutro,
  "Microsoft Flourish Template (Portrait)": microsoftFlourishTemplateWhiteOutro,
  "Microsoft Multiply Template w/ Black Outro": microsoftMultiplyTemplateBlackOutro,
  "Microsoft Multiply Template (Portrait)": microsoftMultiplyTemplateWhiteOutro,
  "Microsoft Prism Template w/ Black Outro": microsoftPrismTemplateBlackOutro,
  "Microsoft Prism Template (Portrait)": microsoftPrismTemplateWhiteOutro,
  "Premise Health Landscape Template w/ Blue Gradient Overlay": premiseHealthLandscapeBlueVideoTemplate,
  "Premise Health Landscape Template w/ Orange Gradient Overlay": premiseHealthLandscapeOrangeVideoTemplate,

  "Story Prompt Overlay (Premise)": storyPromptOverlayPremiseTemplate,
  "Moving circles in background with name and title (Premise)": movingCirclesInBackgroundWithNameAndTitlePremiseTemplate,
  "Branded template for Employee Talking Video (Premise)": brandedTemplateForEmployeeTalkingVideoPremiseTemplate,

  "Santander Landscape w/ White Wordmark Logo Outro and animation": santanderLandscapeWhiteWordmarkLogoOutroAnimation,
  "Santander Landscape w/ Red Wordmark Logo Outro": santanderLandscapeRedWordmarkLogoOutro,
  "Santander Landscape w/ White Wordmark Logo Outro": santanderLandscapeWhiteWordmarkLogoOutro,
  "Santander Landscape w/ Red Logo Outro": santanderLandscapeRedLogoOutro,
  "Santander 4:5 w/ White Logo Outro": santanderWhite_4_5_LogoOutro,
  "Santander 4:5 w/ Red Logo Outro": santanderRed_4_5_LogoOutro,
  "Synopsys Default": synopsysDefaultVideoTemplate,
  "Synopsys Default (Portrait)": synopsysDefaultPortraitVideoTemplate,
  "Verizon Template (Black/Portrait)": verizonTemplateBlackPortrait,
  "Verizon Template (Black/Landscape)": verizonTemplateBlackLandscape,
  "Verizon Template (White/Portrait)": verizonTemplateWhitePortrait,
  "Verizon Template (White/Landscape)": verizonTemplateWhiteLandscape,
  "Zendesk template with cream background": zendeskTemplatewithCreamBackground,
  "Zendesk template with espresso background": zendeskTemplatewithEspressoBackground,
  "Zendesk template with cream background (portrait)": zendeskTemplatewithCreamBackgroundPortrait,
  "Zendesk template with espresso background (portrait)": zendeskTemplatewithEspressoBackgroundPortrait,
  // image templates
  "New Hire Welcome": newHireWelcomeTemplate,
  "Story with Caption and User Overlay": storyWithCaptionAndUserOverlayTemplate,
  "Trend overlay": trendOverlayTemplate,
  "ABK Pride": abkPrideTemplate,
  "Activision Ally": activisionAllyTemplate,
  "Activision Pride": activisionPrideTemplate,
  "Blizzard Ally": blizzardAllyTemplate,
  "ABK Ally": abkAllyTemplate,
  "Blizzard Pride": blizzardPrideTemplate,
  "ILEG Week Empowered to Explore": ilegWeekImage,
  "ILEG Week Dates": ilegWeekImage,
  "ILEG Week Learn, Grow, Perform": ilegWeekImage,
  "ILEG Week Winning Together": ilegWeekImage,
  "ILEG Week Thinking & Talking Development": ilegWeekImage,
  "ILEG Week Take the next step": ilegWeekImage,

  "IRC Image Overlay": ircHumanitarianTemplate,
  // irc default image template
  "Trend overlay (IRC)": trendOverlayIrcTemplate,
  "Story with Caption and User Overlay (IRC)": storyWithCaptionAndUserOverlayIrcTemplate,
  "New Hire Welcome (IRC)": newHireWelcomeIrcTemplate,

  "Recognition Week Overlay Blue": recognitionWeekImageOverlayBlue,
  "Recognition Week Overlay Green": recognitionWeekImageOverlayGreen,
  "Recognition Week Overlay Orange": recognitionWeekImageOverlayOrange,
  "Recognition Week Overlay Pink": recognitionWeekImageOverlayPink,
  "Recognition Week Overlay Purple": recognitionWeekImageOverlayPurple,
  "Recognition Week Overlay Red": recognitionWeekImageOverlayRed,
  "Recognition Week Image Template Intellia (Portrait)": recognitionWeekTemplateIntelliaImage,
  "Recognition Week Image Template Intellia (Landscape)": recognitionWeekTemplateIntelliaImageLandscape,
  "Intuitive Testimonial": intuitiveTestimonialTemplate,
  "Story with Caption and User Overlay for Zendesk": zendeskStoryCaptionUserOverlay,
  "Trend overlay for Zendesk": zendeskTrendOverlay
};

const setCustomTemplate = async (
  template: Template,
  preview: Preview,
  organization: Organization,
  story: Story,
  mediaElements: ElementState[] = []
): Promise<void> => {
  const templateFunction = templateFunctions[template.name];
  if (templateFunction) {
    await templateFunction({
      template, preview, mediaElements, defaultVideoProperties, organization, story
    });
  } else {
    await preview.setSource(await getDefaultSource({ organization, preview }));
  }
};

export default setCustomTemplate;
